import {
  ActivateChannelRequest,
  GioRestEndpoints,
  IGioChannelInfo,
  UpdateGioDeviceChannelRequest,
} from '@scaleaq/sitecontrol-lib';

import { API_NAMES, CACHE_KEYS } from '@/constants';
import {
  useAuthApiDeleteById,
  useAuthApiPost,
  useAuthApiUpdateById,
} from '@/dataAccess/rest/apiHooks';

export const useActivateChannel = (identifier?: string) => {
  return useAuthApiPost<ActivateChannelRequest>({
    baseApiRoute: API_NAMES.gioApi,
    cacheKeys: [CACHE_KEYS.allGioDevices],
    identifier: identifier,
    route: GioRestEndpoints.activateChannel,
  });
};

export const useDeactivateChannelById = (identifier?: string) => {
  return useAuthApiDeleteById<IGioChannelInfo & { id: string }>({
    baseApiRoute: API_NAMES.gioApi,
    cacheKeys: [CACHE_KEYS.allGioDevices],
    identifier: identifier,
    route: GioRestEndpoints.deactivateChannel,
  });
};

export const useUpdateDigitalChannel = (identifier?: string) => {
  return useAuthApiUpdateById<UpdateGioDeviceChannelRequest, boolean>({
    baseApiRoute: API_NAMES.gioApi,
    cacheKeys: [CACHE_KEYS.allGioDevices],
    identifier: identifier || 'useUpdateDigitalChannel',
    route: GioRestEndpoints.updateDigitalChannel,
  });
};
